import axios from 'axios';

const API_URL = process.env.VUE_APP_ZHULIA_BASE_URL;

class ShipmentService {
	async getSalesFulfillmentAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/Inventory/Fulfillments?Limit=-1`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async getBackOrderFulfillmentAsync(authToken) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.get(
				API_URL + `/BackOrders/Fulfillments?Limit=-1`,
				{ headers: headers }
			);

			return response;
		} catch (error) {
			return error.response;
		}
	}

	async updateShipmentsAsync(authToken, request_data) {
		let headers = {
			Authorization: `${authToken}`,
		};
		try {
			const response = await axios.patch(
				API_URL + `/BackOrders/Fulfillments/${request_data.id}`,
				request_data.data,
				{ headers: headers }
			);
			return response;
		} catch (error) {
			return error.response;
		}
	}
}

export default new ShipmentService();
